import ChartCard from '../common/ChartCard';
import BarChart from './BarChart';
import useMetric from '../../hooks/useMetric';

const fmt = (n) => Number(n || 0).toLocaleString('en-US');

/** Marketing CTA chart: impressions vs clicks per period, with the click-through rate. */
export default function CtaPerformanceChart() {
  const { status, data, error, retry } = useMetric('ctaPerformance');
  const hasData = data && data.series.some((s) => s.values.some((v) => v > 0));
  return (
    <ChartCard
      testId="chart-cta-performance" title="Marketing CTA performance"
      subtitle={hasData ? `${fmt(data.totals.clicks)} clicks from ${fmt(data.totals.impressions)} impressions · ${data.totals.clickThroughRate}% click-through` : 'Impressions vs clicks'}
      status={status === 'success' && !hasData ? 'empty' : status} error={error} onRetry={retry}
      emptyText="No call-to-action activity recorded for this period."
    >
      {hasData && <BarChart labels={data.labels} series={data.series} valueFormat={fmt} />}
    </ChartCard>
  );
}
